var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2159_2256",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "url(#pattern0_2159_2256)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2159_2256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.5117,
    y: -10.6875,
    width: 97.0222,
    height: 95.3778,
    fill: "#00FFA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2159_2256",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2159_2256",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2159_2256",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElearning);
export default __webpack_public_path__ + "static/media/elearning.07dfdc58e1cfa0ed268d28326ada01d2.svg";
export { ForwardRef as ReactComponent };